module.exports = __webpack_public_path__ + "static/media/thermoready-5.1c76f9ce.png";